<template>
<object-fit-wrapper class="video-scrolly" :aspectRatio="608 / 1080">
  <template v-slot:default="{contentStyle}">
    <video :style="contentStyle"
      muted
      preload="auto"
      autobuffer
      playsinline
      @canplaythrough="onCanPlayThrough"
      autoplay
      :poster="getSource(poster)"
      ref="video">
      <!-- <source :src="src + '.webm'" type="video/webm"> -->
      <source :src="getVideoSource(src)" type='video/mp4; codecs="avc1.42E01E, mp4a.40.2"'>
    </video>
  </template>

</object-fit-wrapper>
</template>

<script>
import ObjectFitWrapper from './../ObjectFitWrapper.vue'
// autoplay
// :poster="getSource(poster)"
export default {
  props: ['progress', 'src', 'poster', 'slidenum', 'slideIndex'],
  components: {ObjectFitWrapper},
  data () {
    return {
      duration: null,
      framerate: 24,
      animationFrameId: null,
      canPlayThroughFlag: false,
      vid: null
    }
  },
  watch: {
    slideIndex (newVal) {
      if (newVal === this.slidenum) {
        this.animationFrameId = window.requestAnimationFrame(this.scrollPlay)
      } else {
        window.cancelAnimationFrame(this.animationFrameId)
      }
    }
  },
  computed: {
    targetFrame () {
      if (typeof this.progress !== 'number' || typeof this.duration !== 'number') return 0
      // return Math.floor(this.progress * this.duration * this.framerate)
      var target = this.progress * this.duration
      return target
    }
  },
  mounted () {
    this.vid = this.$refs.video
    // this.$loading.startLoading()

    this.vid.addEventListener('loadedmetadata', e => {
      this.duration = this.vid.duration
    })
  },
  beforeDestroy () {
    window.cancelAnimationFrame(this.animationFrameId)
  },
  methods: {
    scrollPlay (newTimeFrame) {
      // Use requestAnimationFrame for smooth playback
      this.vid.currentTime = this.targetFrame
      this.animationFrameId = window.requestAnimationFrame(this.scrollPlay)
    },
    onCanPlayThrough () {
      // this.$loading.endLoading()
      if (!this.canPlayThroughFlag) {
        this.canPlayThroughFlag = true
        this.$emit('canplaythrough')
      }
    },
    getVideoSource (val) {
      if (!val) return ''
      const [path, ext] = val.split('.')
      return require(`videos/${path}-desktop.${ext}`)
    },
    getSource (val) {
      if (val) {
        return require(`videos/${val}`)
      }
      return val
    }
  }
}
</script>

<style lang="scss">
.video-scrolly {
  video {
    @supports (mix-blend-mode: multiply) {
      mix-blend-mode: multiply;
    }

    // width: 100%;
    // height: auto;
    // background-color: black;

    // @supports (object-fit: cover) {
    //   object-fit: cover;
    //   height: 100%;
    // }
  }
}
</style>
